<!-- eslint-disable vue/html-indent -->
<template>
  <div class="fund-amount-form">
    <template v-if="swapCurrency && fundOptions.includes('Wallet')">
      <form @submit.prevent="fundAmount">
        <div class="fund-amount-form__input-group">
          <label class="fund-amount-form__label">Enter amount ({{ getCurrencySymbol(swapCurrency) }})</label>
          <div class="fund-amount-form__input-wrapper">
            <span class="fund-amount-form__currency-symbol">{{ getCurrencySymbol(swapCurrency) }}</span>
            <input
              type="text"
              name="amount"
              :disabled="loading"
              id="amount"
              class="fund-amount-form__input"
              placeholder="0.00"
              :value="displayAmount"
              @input="handleAmountInput"
            />
          </div>
          <p class="fund-amount-form__equivalent" v-if="currencyRate">
            ≈ {{ formatAmountToDollar(swapConversion, 2, currency) }}
          </p>
        </div>
        <div class="fund-amount-form__rate-box" v-if="currencyRate && !loading">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 3V13M8 3L5 6M8 3L11 6M8 13L5 10M8 13L11 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ formatAmountToDollar(1, 2, swapCurrency) }} = {{ formatAmountToDollar(currencyRate, 4, currency) }}</span>
        </div>
        <button
          type="submit"
          class="fund-amount-form__btn"
          :disabled="loading || !fundPayload.amount"
        >
          <span v-if="loading" class="fund-amount-form__spinner"></span>
          <span v-else>Continue</span>
        </button>
      </form>
    </template>
    <template v-else>
      <form @submit.prevent="fundAmount">
        <div class="fund-amount-form__input-group">
          <label class="fund-amount-form__label">Amount to fund</label>
          <div class="fund-amount-form__input-wrapper">
            <span class="fund-amount-form__currency-symbol">{{ getCurrencySymbol(currency) }}</span>
            <input
              type="text"
              :min="minimumDeposit"
              name="amount"
              id="amount"
              class="fund-amount-form__input"
              placeholder="0.00"
              :value="displayAmount"
              @input="handleAmountInput"
            />
          </div>
          <p class="fund-amount-form__min-amount" v-if="minimumDeposit">
            Minimum: {{ formatAmountToDollar(minimumDeposit, 2, currency) }}
          </p>
        </div>
        <button
          type="submit"
          class="fund-amount-form__btn"
          :disabled="loading || !fundPayload.amount"
        >
          <span v-if="loading" class="fund-amount-form__spinner"></span>
          <span v-else>Continue</span>
        </button>
      </form>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { convertToLocale, formatAmountToDollar, getCurrencySymbol } from "@/utils/helpers.js";
import fundPercent from "@/utils/js/fundPercent.js";
import { getItem, setItem } from "@/utils/storage.js";

export default {
  name: "FundAmountForm",

  emits: ["storeData", "close"],

  components: {},

  props: {
    fundOptions: {
      type: String,
      default: () => "",
      required: true,
    },
  },

  data() {
    return {
      user: getItem("org_details"),
      fundPayload: {
        amount: 0,
      },
      transactionFee: 0,
      fundPercent,
      customizations: {
        title: "Getequity Payments",
        description: "Purchase of GUSD from Getequity",
      },

      loading: false,
      // addCard: false,
    };
  },

  inject: ["swapCurrency"],

  computed: {
    ...mapState({
      currency: (state) => state.organisationModule.currency,
      cardDetails: (state) => state.organisationModule.cardDetails,
    }),
    ...mapGetters("organisationModule", ["minimumDeposit", "currencyRate"]),

    swapConversion() {
      if (this.swapCurrency) {
        return this.fundPayload.amount * Number(this.currencyRate);
      }
      return 0;
    },

    displayAmount() {
      return this.fundPayload.amount ? this.convertToLocale(this.fundPayload.amount) : "";
    },

    ...mapGetters("fundingModule", [
      "currentFundPayload",
      "transactionFee",
      "totalAmount",
    ]),

    currentTransactionFee() {
      return this.transactionFee(
        this.fundOptions,
        this.fundPayload.amount,
        this.currency
      );
    },
  },
  watch: {
    "fundPayload.amount"(newAmount) {
      this.updateFundingDetails({
        fundOptions: this.fundOptions,
        amount: newAmount,
        currency: this.currency,
      });
    },
  },
  mounted() {
    this.getMinimumFunding();
    if (this.fundOptions.includes("Wallet")) {
      this.getRate();
    }
    const details = getItem("fundPayload");
    const amount = details?.amount || 0;
    this.fundPayload.amount = amount;
  },

  methods: {
    ...mapActions("organisationModule", ["getMinimumFunding", "convertCurrency"]),
    ...mapActions("fundingModule", ["updateFundingDetails"]),

    formatAmountToDollar,
    convertToLocale,
    getCurrencySymbol,
    handleAmountInput(event) {
      const rawValue = event.target.value.replace(/,/g, "");
      const numValue = parseFloat(rawValue) || 0;
      this.fundPayload.amount = numValue;
    },
    async getRate() {
      const exchangeQuery = {
        from: this.swapCurrency,
        to: this.currency,
        amount: this.fundPayload.amount || 1,
      };
      this.loading = true;
      await this.convertCurrency(exchangeQuery);
      this.loading = false;
    },

    fundAmount() {
      // this.loading = true;
      switch (this.fundOptions) {
        case "Bank or Card":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "P2P Transfers":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "Mobile Money":
        case "Flutterwave Bank Transfer":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "Bank Transfer":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "Fund with debit card":
          this.$emit("storeData", "fundAmountForm");
          // this.flutterwaveFunding();
          break;
        case "":
          this.$emit("storeData", "fundProvider");
          // this.flutterwaveFunding();
          break;
        case "Fund with Fintech Apps":
          // this.thepeerFunding();
          this.$emit("storeData", "fundAmountForm");
          break;
        case "KES Wallet":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "USD Wallet":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "NGN Wallet":
          this.$emit("storeData", "fundAmountForm");
          break;
        case "Crypto":
          // this.fluidCoinFunding();
          this.$emit("storeData", "fundAmountForm");
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$bg-subtle: #F1F5F9;
$border-color: #E2E8F0;
$accent-primary: #6366F1;
$accent-light: #EEF2FF;
$btn-primary: #001240;
$btn-primary-hover: #06206B;
$error: #DC2626;
$error-light: #FEF2F2;

.fund-amount-form {
  width: 100%;

  &__input-group {
    margin-bottom: 24px;
  }

  &__label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: $text-muted;
    margin-bottom: 12px;
  }

  &__input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__currency-symbol {
    position: absolute;
    left: 16px;
    font-size: 24px;
    font-weight: 500;
    color: $text-primary;
    pointer-events: none;
  }

  &__input {
    width: 100%;
    height: 56px;
    padding: 0 16px 0 48px;
    border: 1px solid $border-color;
    border-radius: 10px;
    font-size: 24px;
    font-weight: 500;
    color: $text-primary;
    transition: border-color 0.2s ease;

    &::placeholder {
      color: $border-color;
    }

    &:focus {
      outline: none;
      border-color: $accent-primary;
    }

    &:disabled {
      background: $bg-subtle;
      cursor: not-allowed;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__equivalent {
    margin: 8px 0 0;
    font-size: 13px;
    color: $text-muted;
  }

  &__min-amount {
    margin: 8px 0 0;
    font-size: 13px;
    color: $text-muted;
  }

  &__rate-box {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    background: $bg-subtle;
    border-radius: 10px;
    margin-bottom: 24px;

    svg {
      color: $accent-primary;
    }

    span {
      font-size: 13px;
      color: $text-secondary;

      span:last-child {
        font-weight: 500;
        color: $text-primary;
      }
    }
  }

  &__btn {
    width: 100%;
    height: 48px;
    background: $btn-primary;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    color: white;
    cursor: pointer;
    transition: background 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
      background: $btn-primary-hover;
    }

    &:disabled {
      background: $border-color;
      color: $text-muted;
      cursor: not-allowed;
    }
  }

  &__spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
